/* eslint-disable import/no-cycle, @typescript-eslint/tslint/config */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {
  GetCategoryInitialDataQuery,
  GetCategoryInitialDataQueryVariables,
  GetCategoryInitialDataWithCategoryDataQuery,
  GetCategoryInitialDataWithCategoryDataQueryVariables,
  GetCategoryInitialDataAlwaysFetchCategoriesQueryVariables,
  GetCategoryInitialDataWithCategoryDataAlwaysFetchCategoriesQueryVariables,
  GetCategoryProductsQuery,
  GetCategoryProductsQueryVariables,
  GetDataQuery,
  GetFilteredProductsQuery,
  GetFilteredProductsQueryVariables,
  GetInitialDataForExternalSourceQuery,
  GetProductItemsByProductIdQuery,
  GetRelatedProductsByAlgorithmQuery,
  GetRelatedProductsByAlgorithmQueryVariables,
  ProductFilters,
  ProductSort,
} from '../graphql/queries-schema';
import {Topology} from '@wix/wixstores-client-core/dist/es/src/constants';
import type {IGetInitialData, IOldGetInitialData} from '../types/galleryTypes';
import {query as getSliderGalleryDataQueryString} from '../graphql/getSliderGalleryData.graphql';
import {query as getDataQueryString} from '../graphql/getData.graphql';
import {query as getCategoryProductsQueryString} from '../graphql/getCategoryProducts.graphql';
import {query as getFilteredProductsQueryString} from '../graphql/getFilteredProducts.graphql';
import {query as getRelatedProductsByAlgorithmString} from '../graphql/getRelatedProductsByAlgorithm.graphql';
import {query as getCategoryInitialDataQueryString} from '../graphql/getCategoryInitialData.graphql';
import {query as getCategoryInitialDataAlwaysFetchCategoriesQueryString} from '../graphql/getCategoryInitialDataAlwaysFetchCategories.graphql';
import {query as getCategoryInitialDataWithCategoryDataQueryString} from '../graphql/getCategoryInitialDataWithCategoryData.graphql';
import {query as getCategoryInitialDataWithCategoryDataAlwaysFetchCategoriesQueryString} from '../graphql/getCategoryInitialDataWithCategoryDataAlwaysFetchCategories.graphql';
import {query as getProductByIdQueryString} from '../graphql/getProductById.graphql';
import {query as getProductItemsByProductIdQueryString} from '../graphql/getProductItemsByProductId.graphql';
import {query as getSliderGalleryDataWithoutCombinedListingQueryString} from '../graphql/withoutCombinedListing/getSliderGalleryDataWithoutCombinedListing.graphql';
import {query as getDataWithoutCombinedListingQueryString} from '../graphql/withoutCombinedListing/getDataWithoutCombinedListing.graphql';
import {query as getCategoryProductsWithoutCombinedListingQueryString} from '../graphql/withoutCombinedListing/getCategoryProductsWithoutCombinedListing.graphql';
import {query as getFilteredProductsWithoutCombinedListingQueryString} from '../graphql/withoutCombinedListing/getFilteredProductsWithoutCombinedListing.graphql';
import {query as getRelatedProductsByAlgorithmWithoutCombinedListingString} from '../graphql/withoutCombinedListing/getRelatedProductsByAlgorithmWithoutCombinedListing.graphql';
import {query as getSliderGalleryDataWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getSliderGalleryDataWithoutAdditionalRibbons.graphql';
import {query as getDataWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getDataWithoutAdditionalRibbons.graphql';
import {query as getCategoryProductsWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getCategoryProductsWithoutAdditionalRibbons.graphql';
import {query as getFilteredProductsWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getFilteredProductsWithoutAdditionalRibbons.graphql';
import {query as getRelatedProductsByAlgorithmWithoutAdditionalRibbonsString} from '../graphql/withoutAdditionalRibbons/getRelatedProductsByAlgorithmWithoutAdditionalRibbons.graphql';
import {query as getSliderGalleryDataWithoutCombinedListingWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getSliderGalleryDataWithoutCombinedListingWithoutAdditionalRibbons.graphql';
import {query as getDataWithoutCombinedListingWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getDataWithoutCombinedListingWithoutAdditionalRibbons.graphql';
import {query as getCategoryProductsWithoutCombinedListingWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getCategoryProductsWithoutCombinedListingWithoutAdditionalRibbons.graphql';
import {query as getFilteredProductsWithoutCombinedListingWithoutAdditionalRibbonsQueryString} from '../graphql/withoutAdditionalRibbons/getFilteredProductsWithoutCombinedListingWithoutAdditionalRibbons.graphql';
import {query as getRelatedProductsByAlgorithmWithoutCombinedListingWithoutAdditionalRibbonsString} from '../graphql/withoutAdditionalRibbons/getRelatedProductsByAlgorithmWithoutCombinedListingWithoutAdditionalRibbons.graphql';
import _ from 'lodash';
import {DEFAULT_COLLECTION_ID, MAX_PRODUCTS, Experiments, FedopsInteraction} from '../constants';
import {query as getInitialDataForExternalSource} from '../graphql/getInitialDataForExternalSource.graphql';
import {Filters} from '../types/filters';
import {mapISortingToIProductSortDto, mapISortingToSiteSearchSortDto} from '../services/sort/iSortingToDtoMapper';
import {ISorting, Sorting} from '../types/sorting';
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor';

export interface GetProductsResponse {
  list: GetFilteredProductsQuery['catalog']['category']['productsWithMetaData']['list'];
  totalCount: number;
}

export interface GetProductsRequest {
  collectionId: string;
  offset: number;
  limit: number;
  withOptions: boolean;
  withPriceRange: boolean;
  filters?: Filters;
  sorting?: Sorting;
}

export class DataApi {
  private externalDataSourceGetProducts: (GetProductsRequest) => Promise<GetProductsResponse>;

  constructor(
    private readonly siteStore: SiteStore,
    private readonly panoramaClient: ControllerFlowAPI['panoramaClient'],
    private readonly consumerName: string
  ) {
    //
  }

  public setExternalDataSourceGetProducts(val: (req: GetProductsRequest) => Promise<GetProductsResponse>) {
    this.externalDataSourceGetProducts = val;
  }

  public oldGetInitialData({externalId, compId, limit, withPriceRange, withOptions}: IOldGetInitialData): Promise<{
    data: GetDataQuery;
  }> {
    /* istanbul ignore next */
    const {query: queryString, operationName} = this.getQueryByAdditionalRibbons({
      default: {
        default: {query: getSliderGalleryDataQueryString, operationName: 'getSliderGalleryData'},
        withoutCombinedListing: {
          query: getSliderGalleryDataWithoutCombinedListingQueryString,
          operationName: 'getSliderGalleryDataWithoutCombinedListing',
        },
      },
      withoutAdditionalRibbons: {
        default: {
          query: getSliderGalleryDataWithoutAdditionalRibbonsQueryString,
          operationName: 'getSliderGalleryDataWithoutAdditionalRibbons',
        },
        withoutCombinedListing: {
          query: getSliderGalleryDataWithoutCombinedListingWithoutAdditionalRibbonsQueryString,
          operationName: 'getSliderGalleryDataWithoutCombinedListingWithoutAdditionalRibbons',
        },
      },
    });

    const data: any = {
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
      variables: {externalId: externalId || '', compId, limit, withPriceRange, withOptions},
    };

    return this.sendRequest(data) as Promise<{
      data: GetDataQuery;
    }>;
  }

  public getInitialData({
    externalId,
    compId,
    limit,
    sort,
    filters,
    offset,
    withOptions,
    withPriceRange,
    mainCollectionId,
  }: IGetInitialData): Promise<{
    data: GetDataQuery;
  }> {
    const maxLimit = Math.min(limit, MAX_PRODUCTS);
    const {query: queryString, operationName} = this.getQueryByAdditionalRibbons({
      default: {
        default: {query: getDataQueryString, operationName: 'getData'},
        withoutCombinedListing: {
          query: getDataWithoutCombinedListingQueryString,
          operationName: 'getDataWithoutCombinedListing',
        },
      },
      withoutAdditionalRibbons: {
        default: {query: getDataWithoutAdditionalRibbonsQueryString, operationName: 'getDataWithoutAdditionalRibbons'},
        withoutCombinedListing: {
          query: getDataWithoutCombinedListingWithoutAdditionalRibbonsQueryString,
          operationName: 'getDataWithoutCombinedListingWithoutAdditionalRibbons',
        },
      },
    });

    const data = {
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
      variables: {
        externalId: externalId || '',
        compId: mainCollectionId ? undefined : compId,
        limit: maxLimit,
        sort,
        filters,
        offset,
        withOptions,
        withPriceRange,
        mainCollectionId,
      },
    };

    return this.sendRequest(data) as Promise<{
      data: GetDataQuery;
    }>;
  }

  public getRelatedProductsByAlgorithm({
    externalId = '',
    productIds,
    algorithmId,
    appId,
    withOptions,
    withPriceRange,
  }: {
    externalId: string;
    productIds: string[];
    algorithmId: string;
    appId: string;
    withOptions: boolean;
    withPriceRange: boolean;
  }): Promise<{data: GetRelatedProductsByAlgorithmQuery}> {
    const queryVariables: GetRelatedProductsByAlgorithmQueryVariables = {
      externalId,
      productIds,
      algorithm: {id: algorithmId, appId},
      withOptions,
      withPriceRange,
    };

    /* istanbul ignore next */
    const {query: queryString, operationName} = this.getQueryByAdditionalRibbons({
      default: {
        default: {query: getRelatedProductsByAlgorithmString, operationName: 'getRelatedProductsByAlgorithm'},
        withoutCombinedListing: {
          query: getRelatedProductsByAlgorithmWithoutCombinedListingString,
          operationName: 'getRelatedProductsByAlgorithmWithoutCombinedListing',
        },
      },
      withoutAdditionalRibbons: {
        default: {
          query: getRelatedProductsByAlgorithmWithoutAdditionalRibbonsString,
          operationName: 'getRelatedProductsByAlgorithmWithoutAdditionalRibbons',
        },
        withoutCombinedListing: {
          query: getRelatedProductsByAlgorithmWithoutCombinedListingWithoutAdditionalRibbonsString,
          operationName: 'getRelatedProductsByAlgorithmWithoutCombinedListingWithoutAdditionalRibbons',
        },
      },
    });

    const data: any = {
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
      variables: queryVariables,
    };
    return this.sendRequest(data) as Promise<{data: GetRelatedProductsByAlgorithmQuery}>;
  }

  private getCategoryInitialDataQuery(): {
    query: string;
    operationName: string;
    supportsConditionalCategories: boolean;
  } {
    const useCategoryRouterData = this.siteStore.experiments.enabled(Experiments.UseCategoryRouterData);
    const conditionalCategoriesFetch = this.siteStore.experiments.enabled(
      Experiments.GalleryConditionalCategoriesDataFetch
    );

    if (useCategoryRouterData) {
      if (conditionalCategoriesFetch) {
        return {
          query: getCategoryInitialDataQueryString,
          operationName: 'getCategoryInitialData',
          supportsConditionalCategories: true,
        };
      }
      return {
        query: getCategoryInitialDataAlwaysFetchCategoriesQueryString,
        operationName: 'getCategoryInitialDataAlwaysFetchCategories',
        supportsConditionalCategories: false,
      };
    }

    if (conditionalCategoriesFetch) {
      return {
        query: getCategoryInitialDataWithCategoryDataQueryString,
        operationName: 'getCategoryInitialDataWithCategoryData',
        supportsConditionalCategories: true,
      };
    }
    return {
      query: getCategoryInitialDataWithCategoryDataAlwaysFetchCategoriesQueryString,
      operationName: 'getCategoryInitialDataWithCategoryDataAlwaysFetchCategories',
      supportsConditionalCategories: false,
    };
  }

  /* istanbul ignore next */
  private getQueryByAdditionalRibbons<T>(variants: {
    default: {default: T; withoutCombinedListing: T};
    withoutAdditionalRibbons: {default: T; withoutCombinedListing: T};
  }): T {
    const additionalRibbons = this.siteStore.experiments.enabled(Experiments.AdditionalRibbonsFieldGraphQL);
    return this.getQueryByCombinedListing(additionalRibbons ? variants.default : variants.withoutAdditionalRibbons);
  }

  /* istanbul ignore next */
  private getQueryByCombinedListing<T>(variants: {default: T; withoutCombinedListing: T}): T {
    const combinedListing = this.siteStore.experiments.enabled(Experiments.CombinedListingFetchGroupInfo);
    return combinedListing ? variants.default : variants.withoutCombinedListing;
  }

  private sendRequest(data: any): Promise<any> {
    return this.siteStore.tryGetGqlAndFallbackToPost(
      this.siteStore.resolveAbsoluteUrl(`/${Topology.STOREFRONT_GRAPHQL_URL}`),
      data
    );
  }

  public async getCategoryProducts(
    variables: GetCategoryProductsQueryVariables
  ): Promise<{data: GetCategoryProductsQuery}> {
    /* istanbul ignore next */
    const {query: queryString, operationName} = this.getQueryByAdditionalRibbons({
      default: {
        default: {query: getCategoryProductsQueryString, operationName: 'getCategoryProducts'},
        withoutCombinedListing: {
          query: getCategoryProductsWithoutCombinedListingQueryString,
          operationName: 'getCategoryProductsWithoutCombinedListing',
        },
      },
      withoutAdditionalRibbons: {
        default: {
          query: getCategoryProductsWithoutAdditionalRibbonsQueryString,
          operationName: 'getCategoryProductsWithoutAdditionalRibbons',
        },
        withoutCombinedListing: {
          query: getCategoryProductsWithoutCombinedListingWithoutAdditionalRibbonsQueryString,
          operationName: 'getCategoryProductsWithoutCombinedListingWithoutAdditionalRibbons',
        },
      },
    });

    const data: any = {
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
      variables,
    };

    return this.sendRequest(data);
  }

  public async getProductsByOffset(request: GetProductsRequest) {
    const {collectionId, offset, limit, filters, withOptions, withPriceRange, sorting} = request;
    if (this.externalDataSourceGetProducts) {
      return this.externalDataSourceGetProducts({
        ...request,
        sorting: mapISortingToSiteSearchSortDto(sorting as ISorting),
      });
    }

    const response = await this.getProductsByGraphQL(
      collectionId,
      offset,
      limit,
      filters as ProductFilters,
      withOptions,
      withPriceRange,
      sorting as ISorting
    );
    const {list, totalCount} = response.data.catalog.category.productsWithMetaData;
    return {list: _.compact(list), totalCount};
  }

  public async getProducts({
    collectionId,
    filters,
    fromIndex,
    sorting,
    toIndex,
    withOptions,
    withPriceRange,
  }: {
    collectionId: string;
    fromIndex: number;
    toIndex: number;
    withOptions: boolean;
    withPriceRange: boolean;
    filters?: Filters;
    sorting?: ISorting;
  }): Promise<GetProductsResponse> {
    const offset = fromIndex;
    const limit = toIndex - fromIndex;
    return this.getProductsByOffset({
      collectionId,
      filters,
      sorting,
      withOptions,
      withPriceRange,
      offset,
      limit,
    });
  }

  public async getProductsByGraphQL(
    mainCollectionId: string,
    offset: number,
    limit: number,
    filters: ProductFilters | null,
    withOptions: boolean,
    withPriceRange: boolean,
    sorting?: ISorting
  ): Promise<{data: GetFilteredProductsQuery}> {
    const sort = mapISortingToIProductSortDto(sorting) as ProductSort;

    const variables: GetFilteredProductsQueryVariables = {
      mainCollectionId,
      offset,
      limit,
      sort,
      filters,
      withOptions,
      withPriceRange,
    };

    /* istanbul ignore next */
    const {query: queryString, operationName} = this.getQueryByAdditionalRibbons({
      default: {
        default: {query: getFilteredProductsQueryString, operationName: 'getFilteredProducts'},
        withoutCombinedListing: {
          query: getFilteredProductsWithoutCombinedListingQueryString,
          operationName: 'getFilteredProductsWithoutCombinedListing',
        },
      },
      withoutAdditionalRibbons: {
        default: {
          query: getFilteredProductsWithoutAdditionalRibbonsQueryString,
          operationName: 'getFilteredProductsWithoutAdditionalRibbons',
        },
        withoutCombinedListing: {
          query: getFilteredProductsWithoutCombinedListingWithoutAdditionalRibbonsQueryString,
          operationName: 'getFilteredProductsWithoutCombinedListingWithoutAdditionalRibbons',
        },
      },
    });

    const data = {
      variables,
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
    };

    this.panoramaClient.transaction(FedopsInteraction.GetFilteredProducts).start({componentType: this.consumerName});

    const response = await this.sendRequest(data);

    this.panoramaClient.transaction(FedopsInteraction.GetFilteredProducts).finish({
      componentType: this.consumerName,
      offset,
      limit,
    });

    return response;
  }

  public async getCategoryInitialData(
    params:
      | GetCategoryInitialDataQueryVariables
      | GetCategoryInitialDataWithCategoryDataQueryVariables
      | GetCategoryInitialDataAlwaysFetchCategoriesQueryVariables
      | GetCategoryInitialDataWithCategoryDataAlwaysFetchCategoriesQueryVariables
  ): Promise<{
    data: GetCategoryInitialDataQuery | GetCategoryInitialDataWithCategoryDataQuery;
  }> {
    const {query: queryString, operationName, supportsConditionalCategories} = this.getCategoryInitialDataQuery();
    const withCategories =
      supportsConditionalCategories && 'withCategories' in params ? params.withCategories : undefined;

    const data = {
      variables: {
        externalId: params.externalId || /* istanbul ignore next */ '',
        currentCategoryId: params.currentCategoryId || DEFAULT_COLLECTION_ID,
        withRichContentDescription: params.withRichContentDescription,
        ...(withCategories !== undefined && {withCategories}),
      },
      query: queryString,
      source: 'WixStoresWebClient',
      operationName,
    };

    return this.sendRequest(data);
  }

  public async getInitialDataForExternalSource(
    externalId: string
  ): Promise<{data: GetInitialDataForExternalSourceQuery}> {
    const data: any = {
      query: getInitialDataForExternalSource,
      source: 'WixStoresWebClient',
      operationName: 'getInitialDataForExternalSource',
      variables: {externalId: externalId || /* istanbul ignore next */ ''},
    };

    return this.sendRequest(data);
  }

  public async getProductItemsByProductId(productId: string): Promise<{data: GetProductItemsByProductIdQuery}> {
    const data = {
      variables: {productId},
      query: getProductItemsByProductIdQueryString,
      source: 'WixStoresWeb',
      operationName: 'getProductItemsByProductId',
    };
    return this.sendRequest(data);
  }

  /* istanbul ignore next */
  public async getProductById(productId: string): Promise<{data: {catalog: {product: any}}} | null> {
    const data = {
      variables: {productId, withOptions: true, withPriceRange: false},
      query: getProductByIdQueryString,
      source: 'WixStoresWebClient',
      operationName: 'getProductById',
    };
    return this.sendRequest(data);
  }
}
